import { Observable } from 'rxjs';
import {
  ActionTypeInput,
  ActionType,
  ActionTypeLabel,
} from './entities/action-type-entity';
import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  API_SERVICE_CONFIG,
  IApiServiceConfig,
} from '@fullyops/data/base/configuration/api-service-config';

@Injectable()
export class ApiActionTypeAdapterService {
  private readonly url = this.config.url + 'interventions/types';

  constructor(
    private http: HttpClient,
    @Inject(API_SERVICE_CONFIG) private config: IApiServiceConfig,
  ) {}

  getAll(): Observable<ActionType[]> {
    return this.http.get<ActionType[]>(this.url);
  }

  update(
    label: ActionTypeLabel,
    change: Partial<ActionTypeInput>,
  ): Observable<void> {
    return this.http.patch<void>(`${this.url}/${label}`, change);
  }
}
